<template>
  <!-- <div v-if="is_loading">
    <SkeletonBox width="180px" height="15px" radius="5px" />
  </div> -->
  <v-chart
    ref="chartRef"
    class="chart"
    :option="chartOptions"
    autoresize
  />
</template>

<script setup>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart, BarChart, LineChart } from 'echarts/charts'
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    ToolboxComponent,
    GridComponent
} from 'echarts/components'
import VChart from 'vue-echarts'
import { ref } from 'vue'
use([
    CanvasRenderer,
    PieChart,
    BarChart,
    LineChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    ToolboxComponent,
    GridComponent
])
// const is_loading = ref(false)
const props = defineProps({
    chartOptions: Object
})
</script>

<style scoped>
.echarts {
  width: 100%;
}
</style>
